require('./app');
let SnazzyInfoWindow = require('snazzy-info-window');

function setAuctionsMap() {

    var zoom = 5,
        windowWidth = $(window).width();

    if (windowWidth < 450) {
        zoom = 3.2;
    } else if (windowWidth < 500) {
        zoom = 3.5;
    } else if (windowWidth < 768) {
        zoom = 4;
    } else if (windowWidth < 991) {
        zoom = 4.2;
    } else if (windowWidth < 1200) {
        zoom = 4.5;
    }

    var defaultMapOptions = {
        center: { lat: 39.8283, lng: -98.5795 },
        zoom: zoom,
        mapTypeControl: false,
        disableDefaultUI: true,
        mapTypeId: 'satellite'
    };

    var map = new google.maps.Map(document.getElementById('property-map-object'), defaultMapOptions),
        bounds = new google.maps.LatLngBounds(),
        infoWindow = new google.maps.InfoWindow();

    map.setOptions({ styles: window.helpers.defaultGoogleMapStyles });

    for (var propId in window.auction_properties) {
        if (window.auction_properties.hasOwnProperty(propId)) {
            var property = window.auction_properties[propId];

            var icon = '';
            if (property.is_auction) {
                icon = '/assets/img/map-icons/auction-map-pin.png';
            } else {
                icon = '/assets/img/map-icons/normal-map-pin.png';
            }

            var priceAuctionBlock = '',
                viewLabel = '';

            if (property.is_auction === "true") {
                priceAuctionBlock = '<span class="listing-info">' + property.auction_formatted_date + '</span>';
                viewLabel = "Auction";
            } else {
                priceAuctionBlock = '<span class="listing-info">$' + property.price.format() + '</span>';
                viewLabel = "Property";
            }

            var status = '',
                statusClass = '';

            if (property.price_reduced_date !== "") {
                status = 'Reduced';
                statusClass = 'is-reduced';
            } else if (property.is_auction === "true") {
                if (property.is_current_auction === "true") {
                    status = 'Auction';
                    statusClass = 'is-auction';
                } else {
                    status = 'Past Auction';
                    statusClass = 'is-past-auction';
                    icon = '/assets/img/map-icons/sold-map-pin.png';
                }
            } else if (property.status === "Sold") {
                status = "Sold";
                statusClass = 'is-past-auction';
                icon = '/assets/img/map-icons/sold-map-pin.png';
            }

            var marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(property.latitude),
                    lng: parseFloat(property.longitude)
                },
                map: map,
                title: property.title,
                icon: icon
            });

            var statusContainer = '';
            if (status !== "") {
                statusContainer = '<span class="listing-label">' + status + '</span>';
            }

            var videoContainer = '';
            if (property.has_videos == "true") {
                videoContainer = '<a href="' + property.property_link + '?video=true" class="listing-video"><span class="sr-only">Play Video</span></a>';
            }

            var photosContainer = '';
            if (property.image_count > 0) {
                photosContainer = '<a href="' + property.property_link + '?gallery=true" class="listing-pictures">' + property.image_count + '</a>';
            }

            var isFavorite = false;
            if (window.userFavorites !== undefined && window.userFavorites !== null) {
                for (var i = 0; i < window.userFavorites.length; i++) {
                    if (window.userFavorites[i] === property.id) {
                        isFavorite = true;
                    }
                }
            }

            if ($('#current-user-id').val() !== undefined) {
                var favoriteClass = (isFavorite) ? 'is-favorite' : '';
                var favoriteContent = '<a class="listing-favorite map-listing-favorite user-is-logged-in ' + favoriteClass + '" data-property-id="' + property.id + '"><span class="sr-only">Add to favorites</span></a>';
            } else {
                var favoriteContent = '<a data-toggle="modal" data-target="#insiders-register-form" class="listing-favorite map-listing-favorite" data-property-id="' + property.id + '"><span class="sr-only">Add to favorites</span></a>';
            }

            var listingBody = property.ad_30_word,
                trimmedlistingBody = listingBody.substring(0, 105);
            var trimmedlistingBody = trimmedlistingBody.substr(0, Math.min(trimmedlistingBody.length, trimmedlistingBody.lastIndexOf(" ")));


            var content = '' +
                '<div class="property-item no-hover-for-map popup-inner-container ' + statusClass + '">' +
                '<div class="popup-left-container">' +
                '<div class="listing-img map-listing-img">' +
                '<a href="' + property.property_link + '" class="map-listing-image" style="background-image:url(' + property.listing_image + ')"></a>' +
                statusContainer + videoContainer + photosContainer + favoriteContent +
                '</div>' +
                '</div>' +
                '<div class="popup-right-container listing-body for-map">' +
                '<div class="listing-body-internal">' +
                '<div class="listing-header">' +
                '<a href="' + property.property_link + '"><h3 class="heading-tertiary">' + property.title + '</h3></a>' +
                '<span class="heading-quaternary">' + property.city + ', ' + property.state + '</span>' +
                '</div>' +
                '<p class="listing-body-map-ad">' + trimmedlistingBody + ' ...</p>' +
                '</div>' +
                '<div class="listing-details row no-gutters">' +
                '<div class="col"><div class="listing-size">' + property.deeded_acres.toLocaleString() + '± Deeded Acres</div></div>' +
                '<div class="col text-right">' + priceAuctionBlock + '</div>' +
                '</div>' +
                '<a class="btn btn-secondary" href="' + property.property_link + '">View ' + viewLabel + ' Details</a>' +
                '</div>' +
                '</div>' +
                '';

            var infoWindowNew = new SnazzyInfoWindow({
                marker: marker,
                content: content,
                closeWhenOthersOpen: true,
                callbacks: {
                    afterOpen: function () {
                        if ($(window).width() < 768) {
                            $('#property-map-zoom-controls').addClass('d-none');
                        }

                        $('.map-listing-favorite').on('click', function () {

                            if ($(this).data('toggle') === "modal") {
                                var target = $(this).data('target');
                                $(target).modal('show');
                            } else {
                                if ($(this).hasClass('user-is-logged-in')) {
                                    var selecting = (!$(this).hasClass('is-favorite')),
                                        parent = $(this).parent().parent('.property-item');
                                    $(this).toggleClass('is-favorite');
                                    parent.toggleClass('is-favorite');

                                    var propertyId = $(this).data('property-id'),
                                        userId = $('#current-user-id').val();

                                    var _this = $(this);

                                    $.post("/wp/wp-admin/admin-ajax.php", {
                                        'action': 'favorite_property',
                                        'property_id': propertyId,
                                        'user_id': userId,
                                        'mode': (selecting) ? 'select' : 'unselect'
                                    }, function (data) {
                                        // If on the profile page, remove the favorite the page
                                    });
                                }
                            }

                        });
                    }, afterClose: function () {
                        if ($(window).width() < 768) {
                            $('#property-map-zoom-controls').removeClass('d-none');
                        }
                    }
                }
            });

            google.maps.event.addListener(marker, 'click', (function (marker, content, infoWindow) {
                return function () {
                    // infoWindow.close();
                    // infoWindow.setContent(content);
                    // infoWindow.open(map, marker);
                }
            })(marker, content, infoWindow));

            google.maps.event.addListener(map, "click", function (event) {
                infoWindow.close();
                infoWindowNew.close();
            });

            $('#property-map-object').on('click', function (e) { e.stopPropagation(); });

            $('body').on('click', function () { infoWindow.close(); infoWindowNew.close(); });
        }
    }

    $("#property-map-style-toggle").off();
    $("#property-map-style-toggle").on('click', function () {
        if ($(this).hasClass('is-satellite')) {
            $(this).removeClass('is-satellite').addClass('is-terrain');
            $(this).html('Terrain');
            map.setMapTypeId('satellite');
        } else if ($(this).hasClass('is-terrain')) {
            $(this).addClass('is-satellite').removeClass('is-terrain');
            $(this).html('Satellite');
            map.setMapTypeId('terrain');
        }
    });

    $('#property-map-zoom-in').off();
    $('#property-map-zoom-in').on('click', function () {
        map.setZoom(map.getZoom() + 1);
    });

    $('#property-map-zoom-out').off();
    $('#property-map-zoom-out').on('click', function () {
        map.setZoom(map.getZoom() - 1);
    });

}

if ($('#auctions-map').length) {
    setAuctionsMap();
}
